/* 检查浏览器类型 */
class BrowserCheck {
  _ua = navigator.userAgent.toLowerCase()

  /**
   * 获取浏览器类型（浏览器不是操作系统，如微信，支付宝，uc等）
   * @readonly
   * @memberof BrowserCheck
   * @returns {string='wechat','browser'}
   */
  get browser() {
    if (this.isWechat) {
      return 'wechat'
    } else if (this.isAlipay) {
      return 'alipay'
    } else if (this.isSafari) {
      return 'safari'
    } else if (this.isIlistenAndroid) {
      return 'ilistenAndroid'
    } else if (this.isIlistenIos) {
      return 'ilistenIos'
    } else {
      return 'browser'
    }
  }

  /**
   * 获取手机操作系统
   * @readonly
   * @memberof BrowserCheck
   */
  get system() {
    if (this.isIphone) {
      return 'iphone'
    } else if (this.isAndroid) {
      return 'android'
    } else {
      return 'other'
    }
  }

  get isIlisten () {
    return this.isIlistenAndroid || this.isIlistenIos
  }

  get isIlistenIos () {
    return this._ua.indexOf('ilisten_ios') !== -1
  }

  get isIlistenAndroid () {
    return this._ua.indexOf('ilisten_android') !== -1
  }

  /**
   *是否是微信
   * @readonly
   * @memberof BrowserCheck
   * @returns {boolean}
   */
  get isWechat() {
    return this._ua.indexOf('micromessenger') !== -1
  }

  /**
   * 是否是支付宝浏览器
   * @readonly
   * @memberof BrowserCheck
   * @returns {boolean}
   */
  get isAlipay() {
    return /Alipay/i.test(this._ua)
  }

  /**
   * 是否是支付宝浏览器
   * @readonly
   * @memberof BrowserCheck
   * @returns {boolean}
   */
  get isSafari() {
    return /Safari/i.test(this._ua) && !/Chrome/i.test(this._ua)
  }

  /**
   *是否是ios
   * @readonly
   * @memberof BrowserCheck
   * @returns {boolean}
   */
  get isIphone() {
    return this._ua.indexOf('like mac os x') !== -1
  }

  /**
   *是否是android
   * @readonly
   * @memberof BrowserCheck
   * @returns {boolean}
   */
  get isAndroid() {
    return this._ua.indexOf('android') > -1 || this._ua.indexOf('adr') > -1
  }
}

export default new BrowserCheck()
